module.exports = __webpack_public_path__ + "media/images/patterns/shattered-adf86f85f18ccc554802be1742d3977b.png";